var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"30px"}},[_c('a',{attrs:{"href":_vm.pliDomain,"target":"_blank"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin":"0 auto"},attrs:{"src":_vm.logoUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }